import React from "react";
import useActiveService from "../hooks/useActiveService"
import { Link } from "react-router-dom";
import { Service } from "../core/_models";
import useLocalizedCopy from "../hooks/useLocalizedCopy";

export function ActiveServiceBanner({ viewingService = null }: { viewingService?: Service | null }) {
    const {
        loadingError,
        activeService
    } = useActiveService();
    const { copy } = useLocalizedCopy();

    if (loadingError) {
        return (
            <div className="mb-5">
                <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative" role="alert">
                    <span className="block sm:inline">
                        {loadingError}
                    </span>
                </div>
            </div>
        );
    }

    if (!activeService) {
        return null;
    }

    if (viewingService && viewingService.unique_identifier === activeService.unique_identifier) {
        return <div className="mb-5">
            {/* Show an info banner about the active service */}
            <div className="bg-blue-100 border border-blue-400 text-blue-700 px-4 py-3 rounded relative" role="alert">
                <span className="block sm:inline">
                    {copy.Common.labels.status}: {copy.Common.labels.active}. {copy.Services.view.endService} <Link to={`/services/${activeService.unique_identifier}/end`} className="font-bold underline">{copy.Common.labels.loading}</Link>.
                </span>
            </div>
        </div>
    }

    // we return null now because we have a concept of multiple active services
    // and it's now reasonably annoying to see other active services, unless it's the current one

    return null;


    return <div className="mb-5">
        {/* Show an info banner about the active service */}
        <div className="bg-blue-100 border border-blue-400 text-blue-700 px-4 py-3 rounded relative" role="alert">
            <span className="block sm:inline">
                {copy.Services.list.serviceFor} <strong>{`${activeService.public_data.deceased_person.full_name}`}</strong> {copy.Common.labels.active}.
                <Link
                    to={`/services/${activeService.unique_identifier}/details`}
                    className="font-bold underline"
                >
                    {copy.Common.buttons.edit}
                </Link>
            </span>
        </div>
    </div>
}